import { useContext } from "react";
import { SeasonContext } from "../../../store/SeasonContext";
import { ModalContext } from "../../../store/ModalContext";
import { HamburgerMenuContext } from "../../../store/HamburgerMenuContext";
import { SubscriptionsContext } from "../../../store/SubscriptionsContext";
import { StartSeasonModalBody } from "../modals/StartSeasonModalBody";

type NavigateSeasonsButtonProps = {
  loading: boolean;
};

const NavigateSeasonsButton = ({ loading }: NavigateSeasonsButtonProps) => {
  const { areWeInSeason, updateAreWeInSeason } = useContext(SeasonContext);
  const { refetch } = useContext(SubscriptionsContext);
  const { openModal, closeModal } = useContext(ModalContext);
  const { closeHamburgerMenu } = useContext(HamburgerMenuContext);

  const closeMenuAndOpenModal = (config: Parameters<typeof openModal>[0]) => {
    closeHamburgerMenu();
    // Open on next tick so burger-menu can finish state update first.
    window.setTimeout(() => openModal(config), 0);
  };

  const handleEndSeason = () => {
    closeMenuAndOpenModal({
      title: "WARNING",
      body: (
        <>
          {" "}
          <div className="info-card warning-card">
            Your clients will lose their CSA memberships and all pickups in the
            delivery list will be deleted.
          </div>{" "}
          <br />
          <p>
            Are you sure you want to end the season? There is no going back
            after the season is ended.{" "}
          </p>
        </>
      ),
      buttons: [
        { text: "Go Back", callback: closeModal },
        {
          text: "End Season",
          loadingText: "Saving...",
          callback: async () => {
            const success = await updateAreWeInSeason(false);
            closeModal();
            if (success) {
              closeHamburgerMenu();
              await refetch();
              openModal({
                title: "Success!",
                body: "The season has ended successfully! Enjoy the break!",
                showCloseButton: true,
              });
            }
          },
        },
      ],
    });
  };

  const handleStartSeasonConfirm = async () => {
    const success = await updateAreWeInSeason(true);
    if (success) {
      closeHamburgerMenu();
      await refetch();
    }
  };

  const handleStartSeason = () => {
    closeMenuAndOpenModal({
      title: "WARNING",
      body: <StartSeasonModalBody onConfirm={handleStartSeasonConfirm} />,
      showCloseButton: true,
    });
  };

  return (
    <div className="operation-controls-buttons">
      <button
        className={
          areWeInSeason
            ? "btn operation-controls-btn active-operation-controls-btn"
            : "btn operation-controls-btn"
        }
        onClick={handleStartSeason}
        disabled={loading || areWeInSeason}
      >
        Start the Season
      </button>

      <button
        className={
          !areWeInSeason
            ? "btn operation-controls-btn active-operation-controls-btn"
            : "btn operation-controls-btn"
        }
        onClick={handleEndSeason}
        disabled={loading || !areWeInSeason}
      >
        Close the Season
      </button>
    </div>
  );
};

export default NavigateSeasonsButton;
